<template>
  <div class="nav-item flex-center" @click="clickNavItem(data)">
    <div v-if="isSvg" class="nav-img" v-html="svgUrl"></div>
    <img v-else :src="imgUrl" alt="" class="nav-img">
    <p class="nav-name">{{ data.applicationName }}</p>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { setToken } from '@/helpers/auth'
import { isSvg } from '@/helpers/validate'

export default {
  name: 'AppItem',
  props: {
    data: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      loadingComponent: null,
      isLoading: false,
      isSvg: true,
      svgUrl: '',
      imgUrl: ''
    }
  },
  computed: {
    accountInfo() {
      return this.$store.getters.accountInfo
    },
    currCustomer() {
      return this.$store.getters.currCustomer
    },
    currDcpRoles() {
      return this.$store.getters.currDcpRoles
    }
  },
  watch: {
    isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: '',
          spinner: 'cricle_loader',
          background: 'rgba(255, 255, 255, 0)'
        })
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    }
  },
  mounted() {
    if (!this.data.applicationIcon) return

    this.isSvg = isSvg(this.data.applicationIcon)
    if (this.isSvg) {
      this.$api.svg.getSvg(this.data.applicationIcon).then((res) => {
        this.svgUrl = res
      })
    } else {
      this.imgUrl = this.data.applicationIcon
    }
  },
  methods: {
    dataTracking(tmp) {
      this.$api.login.dataTracking(tmp).then(res => {

      }).catch(err => {
        console.log(err)
      })
    },
    clickNavItem(item) {
      if (!item) return
      this.gtag('event', `usr_click_${item.applicationCode}`)
      const tmp = {
        eventName: 'open',
        targetType: 'APP',
        targetPk: item.applicationInfoPk,
        agentType: 'PC',
        appParams: item.applicationCode,
        uuid: this.accountInfo.accountUuid,
        customerNumber: this.currCustomer.customerNumber,
        roleCode: this.currDcpRoles[0].roleCode
      }
      this.dataTracking(tmp)

      console.log(item.applicationCode)
      const dcpToken = Cookies.get('dcp-token')
      // 比对
      if (dcpToken !== this.$store.getters.token) {
        this.$confirm('您已被登出', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          customClass: 'dcp-message-box',
          confirmButtonClass: 'dcp-message-box-confirm-btn',
          cancelButtonClass: 'dcp-message-box-cancel-btn'
        })
          .then(() => {
            this.$router.push('/login')
          })
          .catch(() => {})
        return
      }

      this.checkToken(item).then((url) => {
        this.isLoading = false
        const newWindow = window.open('about:blank', '_blank')
        // 修改新窗口的url
        newWindow.blur()
        newWindow.opener.focus()
        newWindow.location.href = url
      })
    },
    checkToken(item) {
      let accessToken = Cookies.get('accessToken')
      let bizType = ''
      if (accessToken) {
        // accessToken未过期
        bizType = ''
      } else {
        // accessToken过期被删除
        bizType = 'refresh_ids_access_token'
      }

      return new Promise((resolve) => {
        this.isLoading = true
        this.$api.login
          .checkToken({ bizType })
          .then((res) => {
            console.log('===', res)
            // this.isLoading = false
            if (res.data.accessToken) {
              // accessToken过期，新数据替换
              // 替换token
              setToken(res.data.token)
              // 设置accessToken
              accessToken = res.data.accessToken
              let date = new Date().getTime()
              date += res.data.accessTokenTimeout * 1000
              const accessTokenTimeout = new Date(date)
              Cookies.set('accessToken', res.data.accessToken, {
                expires: accessTokenTimeout
              })

              this.$store.dispatch('user/SET_ACCESS_TOKEN', {
                token: res.data.token,
                accessToken: res.data.accessToken,
                accessTokenTimeout: res.data.accessTokenTimeout
              })
            }
            // window.open(`${item.applicationRedirectUri}?access_token=${accessToken}`)

            // const aEl = document.createElement('a')
            // aEl.setAttribute('href', `${item.applicationRedirectUri}?access_token=${accessToken}`)
            // aEl.setAttribute('target', '_blank')
            // console.log(aEl)
            // aEl.click()
            if (res.data.agreements && res.data.agreements.length > 0) {
              this.$store.dispatch('user/SET_AGREEMENTS', res.data.agreements)
              return
            }
            resolve(
              `${item.applicationRedirectUri}?access_token=${accessToken}`
            )
          })
          .catch(() => {
            this.isLoading = false
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-item {
  flex-direction: column;
  width: 100%;
  height: 136px;
  border-radius: 4px;
  cursor: pointer;

  .nav-name {
    margin-top: 10px;
    font-weight: 500;
    font-size: 16px;
  }

  @include background_color_page_primary("bg-color-light");
  @include color_page_primary("font-color-diff");
}
</style>

<style lang="scss">
.nav-img {
  width: auto;
  max-width: 184px;
  height: 40px;

  .icon,
  svg {
    width: auto;
    max-width: 184px;
    height: 40px !important;

    @include svg_color_page_primary("color");
  }
}
</style>
